// extracted by mini-css-extract-plugin
export default {"imageWrapper":"yP-z","hovered":"zP-z","hoverImage":"AP-z","mainImage":"BP-z","imageNoBackground":"CP-z","fullSizeImage":"DP-z"};